import GenericPage from '../components/generic/GenericPage'
import tiles from '../components/generic/Tiles'

const MapGEE = () => {
  return (
    <GenericPage title="GEE" frame="https://soil-erosion-new.projects.earthengine.app/view/new-ndvi" tiles={tiles.back('sensing')} frame_offset={70}/>
  )
}
export default MapGEE
